export enum ApplicationMountState {
  MOUNTED = 'MOUNTED',
  UNMOUNTED = 'UNMOUNTED'
}
